import { action, thunk } from 'easy-peasy'
import axios from 'Utils/axios'
import { attributes_schema } from 'Components/CJPopover/NodeConfigs/constants'

const SEGMENTATION = [
  {
    segments: [],
    condition: null,
  },
]

const initState = {
  dimensionModalVisible: false,
  // 👇 should load from API
  dimensions: [],
  data: SEGMENTATION,
  currentGroup: 0,
  isFetching: false,
}

export default {
  ...initState,
  addSegment: action((state, { audience }) => {
    state.data[state.currentGroup].segments.push(audience)
    state.dimensionModalVisible = false
    state.editingSegment = null
  }),
  setState: action((state, { key, value }) => {
    state[key] = value
  }),
  setCurrentGroup: action((state, { index }) => {
    state.currentGroup = index
  }),
  delSegment: action((state, { groupIndex, index }) => {
    state.data[groupIndex].segments.splice(index, 1)
    // Close modal if we're deleting from the modal
    if (state.editingSegment && state.editingSegment.index === index) {
      state.dimensionModalVisible = false
      state.editingSegment = null
    }
  }),
  updateSegment: action((state, { groupIndex, index, segment }) => {
    state.data[groupIndex].segments[index] = segment
    state.dimensionModalVisible = false
    state.editingSegment = null
  }),
  addSegmentGroup: action((state, { groupCondition }) => {
    state.data.push({
      segments: [],
      condition: groupCondition,
    })
  }),
  switchAudienceGroupCondition: action((state, { groupIndex, groupCondition }) => {
    state.data[groupIndex].condition = groupCondition
  }),
  delSegmentGroup: action((state, { index }) => {
    state.data.splice(index, 1)
    state.data[0].condition = null
  }),
  toggleDimensionModal: action((state, type) => {
    state.dimensionModalVisible = !state.dimensionModalVisible
  }),
  onDimensionModalCancel: action((state, type) => {
    state.dimensionModalVisible = false
    state.editingSegment = null
  }),
  fetchDimensions: thunk(async (actions, { type, entranceChannel }, { getState, getStoreState }) => {
    let resp
    let dimensions = []

    if (type === 'check_user_attr') {
      // resp = await axios.get('/customer-journeys/nodes/condition')
      resp = await axios.get(
        `${process.env.REACT_APP_CJ_API_HOST}api/v1/customer-journeys/attributes`
      )
      
      if (resp.status === 200) {
        dimensions = resp.data
      }

      // Nếu có entranceChannel, fetch thêm attributes của entrance channel
      if (entranceChannel) {
        try {
          const entranceResp = await axios.get(
            `${process.env.REACT_APP_CJ_API_HOST}api/v1/customer-journeys/entrances`
          )
          
          if (entranceResp.status === 200) {
            const entrance = entranceResp.data.find(e => e.code === entranceChannel)
            
            // Nếu entrance có attribute, merge vào dimensions
            if (entrance && entrance.attribute) {
              dimensions = [...dimensions, ...entrance.attribute]
            }
          }
        } catch (error) {
          console.error('Error fetching entrance attributes:', error)
        }
      }

      actions.setState({ key: 'dimensions', value: dimensions })
      return
    }

    if (type === 'kariba') {
      resp = await axios.get('/audience-dimensions/', {
        params: {
          as_type: type,
          company: process.env.REACT_APP_COMPANY_NAME,
        },
      })
      
      if (resp.status === 200) {
        actions.setState({ key: 'dimensions', value: resp.data })
        return
      }
    }

    return { errors: resp?.response?.data }
  }),
  resetState: action((state) => ({ ...initState })),
  resetDimension: action((state) => {
    state.data = SEGMENTATION
  }),
}
